import { BaseDto } from "src/dtos/common/baseDto";
import { OrganizationDto } from "src/dtos/organization/organizationDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface SYS4100_R01Dto extends OrganizationDto {

	upOrgNm: string;
	orgAdminNm: string;
	mergeOrgNm: string;
}

export const defaultSYS4100_R01Dto: SYS4100_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	orgCd: "",
	orgNm: "",
	upOrgCd: "",
	upOrgNm: "",
	displaySeq: 0,
	orgAdmin: '',
	orgAdminNm: '',
	createDt: formatDate(new Date()),
	dueDt: '',
	useYn: "Y",
	mergeOrgCd: '',
	mergeOrgNm: '',
	topOrganiza: "N",
	approveFlg: 'N',
	approveEmpNo: '',
	remark: "",

	inserted: false,
	isModified: false,
}